import { withInstall } from '../_util'

import LovQuerytableInner from './LovQuerytable.vue'
import LovPagetableInner from './LovPagetable.vue'

export const LovQuerytable = withInstall(LovQuerytableInner)
export const LovPagetable = withInstall(LovPagetableInner)
